// 将数组中的无效字符串 '' 替换成 undefined

export function filterArr (arr) {
  return arr.map(item => {
    if (item === '') {
      return undefined
    } else {
      return item
    }
  })
}
